import { Component, OnInit, ViewContainerRef, OnDestroy, ViewChild } from '@angular/core';
import { TdDataTableService, TdDataTableSortingOrder, ITdDataTableSortChangeEvent, ITdDataTableColumn, TdDialogService, TdLoadingService, TdSearchBoxComponent } from '@covalent/core';
import { IPageChangeEvent } from '@covalent/core';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { SettingsService } from '../../../shared/services/settings.service';
import { ExportService } from '../../../shared/services/export.service';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { Invoice } from '../invoice';
import { Branch } from '../branch';
import { InvoiceService } from '../../../shared/services/invoice.service';
import { AccountingService } from '../accounting.service';
import { Payment } from '../payment';
import { PaymentInvoice } from '../payment-invoice';
import { NewAdvanceDialogComponent } from '../../../shared/dialogs/new-advance-dialog/new-advance-dialog.component';
import { NewCreditDialogComponent } from '../../../shared/dialogs/new-credit-dialog/new-credit-dialog.component';
import { ReportService } from '../../../shared/services/report.service';
import { SelectCustomerDialog } from '../../../shared/dialogs/select-customer-dialog/select-customer-dialog.component';
import { Customer } from '../customer';
import { DateSelectDialogComponent } from '../../../shared/dialogs/date-select-dialog/date-select-dialog.component';
import { NewInvoiceDialogComponent } from '../../../shared/dialogs/new-invoice-dialog/new-invoice-dialog.component';
import { DateRangeDialogComponent } from '../../../shared/dialogs/date-range-dialog/date-range-dialog.component';
import { InvoiceDetailsDialogComponent } from '../../../shared/dialogs/invoice-details-dialog/invoice-details-dialog.component';
import { MdDialogRef } from '@angular/material';
import { Utils } from '../../../shared/utils';

@Component({
  selector: 'app-invoice-list',
  templateUrl: './invoice-list.component.html',
  styleUrls: ['./invoice-list.component.scss'],
  providers: [InvoiceService, ReportService, AccountingService]
})
export class InvoiceListComponent implements OnInit, OnDestroy {
  @ViewChild('searchBox') _searchBox: TdSearchBoxComponent;

  data: Invoice[];
  subscription: Subscription = new Subscription();

  allBranches$: Observable<Branch[]>;

  branchFilter: string = 'ALL';

  columns: ITdDataTableColumn[] = [
    { name: 'id', label: 'Invoice #', },
    { name: 'customer', label: 'Client' },
    { name: 'invoice_date', label: 'Invoice Date' },
    { name: 'type', label: 'Type' },
    { name: 'total', label: 'Total' },    
    { name: 'processed', label: 'Processed' },
    //{ name: 'debit', label: 'Debit' },
    //{ name: 'credit', label: 'Credit' },
    { name: 'balance', label: 'Balance' },
    { name: 'cheques', label: 'Cheques' },
    { name: 'branch', label: 'Branch' },
  ];

  filteredData: any[];
  filteredTotal: number;
  fromRow: number = 1;
  currentPage: number = 1;
  sortBy: string = 'invoice_date';
  selectedRows: any[] = [];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Ascending;
  selectable: boolean = true;
  multipleSelect: boolean = true;

  all_invoices: Invoice[];

  constructor(private _dataTableService: TdDataTableService,
    private _dialogService: TdDialogService,
    private _invoiceService: InvoiceService,
    private _accountingService: AccountingService,
    private _reportService: ReportService,
    private _loadingService: TdLoadingService,
    private _settingsService: SettingsService,
    private _viewContainerRef: ViewContainerRef,
    public _exportService: ExportService,
    public _authService: AuthenticationService) { }

  ngOnInit(): void {
    this._loadingService.register('loading');

    this.presetSearchBox();

    this.subscription = this._invoiceService
      .getInvoices()
      .subscribe((invoices: Invoice[]) => {
        this.all_invoices = invoices;

        // Display only this user's branches invoices
        // TODO: Make this also filter in the BE
        this.data = this.all_invoices.slice().filter(i => { return this._authService.getUserBranches().some(b => { return i.branch_id == b.id }) });
        /*
        this.filteredData = this.data;
        this.filteredTotal = this.data.length;
        this.selectedRows = this.filteredData;
        */
        this.filter();
        this._loadingService.resolve('loading');

      },
        error => {
          this._loadingService.resolve('loading');
        });

    // Use user's branches
    this.allBranches$ = Observable.of(this._authService.getUserBranches())
    //this.allBranches$ = this._invoiceService.getBranches();
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  presetSearchBox() {
    if (this._settingsService.getSearchTerm('invoice')) {
      this._searchBox.value = this._settingsService.getSearchTerm('invoice');
      this._searchBox.searchClicked();
    }
  }

  newInvoice() {
    this._dialogService.open(NewInvoiceDialogComponent).afterClosed().subscribe(
      r => {
        if (r) {
          this._invoiceService.getInvoices().subscribe(
            (invoices: Invoice[]) => {
              this.all_invoices = invoices;
              this.data = this.all_invoices.slice();
              this.filter();
            }

          );
        }
      }
    )
  }

  editInvoiceNumber(row) {
    this._dialogService.openPrompt({ title: 'Enter new value', message: 'Enter new invoice number', value: row['invoice_number'] }).afterClosed().subscribe(
      result => {
        if (result) {
          this._invoiceService.changeInvoiceNumber(row['id'], result).subscribe(
            r => {
              console.log("si femei de 7 stele");
              console.log(r);

              if (r.status == 'SUCCESS') {
                row['invoice_number'] = result;
              } else {
                this._dialogService.openAlert({ title: 'Error', message: 'Could npt update invoice number' })
              }
            }
          );
          console.log(result);
        }
      }
    );
  }

  newAdvance() {
    this._dialogService.open(NewAdvanceDialogComponent).afterClosed().subscribe(
      r => {
        if (r) {
          this._invoiceService.getInvoices().subscribe(
            (invoices: Invoice[]) => {
              this.all_invoices = invoices;
              this.data = this.all_invoices.slice();
              this.filter();
            }

          );
        }
      }
    )
  }

  newCredit() {
    this._dialogService.open(NewCreditDialogComponent).afterClosed().subscribe(
      r => {
        if (r) {
          this._invoiceService.getInvoices().subscribe(
            (invoices: Invoice[]) => {
              this.all_invoices = invoices;
              this.data = this.all_invoices.slice();
              this.filter();
            }
          );
        }
      }
    );
  }

  customerSummaryReport() {
    if (this.branchFilter == 'ALL') {
      this._dialogService.openAlert({ title: 'Select Branch', message: 'Please select a branch in the filter to generate the report' });
      return;
    }

    let dRef: MdDialogRef<DateSelectDialogComponent> = this._dialogService.open(DateSelectDialogComponent);

    dRef.componentInstance.instruction = 'Select To Date';

    dRef.afterClosed().subscribe(
      result => {
        if (result) {

          let branch = this._authService.getUserBranches().find(b => { return b.code == this.branchFilter })

          this._reportService.getCustomerSummaryReportData(
            result.date,
            branch.id.toString()).subscribe(
              data => {
                this._reportService.customerSummaryReport(
                  data,
                  branch,
                  result.date);  
              }
          );
        }
        
      });
  }

  customerAccountReport() {
    if (this.branchFilter == 'ALL') {
      this._dialogService.openAlert({ title: 'Select Branch', message: 'Please select a branch in the filter to generate the report' });
      return;
    }

    let _customerDialogRef: MdDialogRef<SelectCustomerDialog> = this._dialogService.open(SelectCustomerDialog);
    _customerDialogRef.componentInstance.branch_id = this.branchFilter;
    _customerDialogRef.afterClosed().subscribe(

    //this._dialogService.open(SelectCustomerDialog).afterClosed().subscribe(
      (result: Customer) => {
        if (result) {
          this._dialogService.open(DateRangeDialogComponent).afterClosed().subscribe(
            dates => {
              if (dates) {
                  this._reportService.getCustomerAccountReportData(dates.from, dates.to, result.id).subscribe(
                    data => {

                      console.log(data);
                      if (data && data.length > 0) {
                        // assign the selected branch to the customer to be passed in to the report
                        result.branch = this.branchFilter;
                        this._reportService.customerAccountReport(data, result, dates.from, dates.to);
                      } else {
                        this._dialogService.openAlert(
                          {
                            title: 'No data',
                            message: 'There are no invoices for the selected customer at this branch between the selected dates'
                          }
                        );
                      }
                    },
                    error => {
                      this._dialogService.openAlert(
                        {
                          title: 'Error',
                          message: 'There was an error retrieving the data: ' + error
                        }
                      );

                    }
                  );

              } else {
                this._dialogService.openAlert(
                  {
                    title: 'Invalid data',
                    message: 'Please select a valid date range'
                  }
                )
              }
            }
          );
        } else {
          this._dialogService.openAlert(
            {
              title: 'Invalid data',
              message: 'Please select a valid customer'
            }
          )
        }
      }
    );
  }

  viewProcessed(row: any) {

    let _invoice = row['id'];

    let dRef: MdDialogRef<InvoiceDetailsDialogComponent> = this._dialogService.open(InvoiceDetailsDialogComponent);
    dRef.componentInstance.invoice_id = _invoice;
  }

  getTotal(arr: any[], field: string) {
    return (arr || []).reduce((a, b) => { return a + Number.parseFloat(b[field]) }, 0);
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;

    this.sortOrder = sortEvent.order === TdDataTableSortingOrder.Ascending
      ? TdDataTableSortingOrder.Descending
      : TdDataTableSortingOrder.Ascending;

    this.filter();
  }

  search(searchTerm: string): void {
    this._settingsService.setSearchTerm('invoice', searchTerm);
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;
    this._settingsService.setPageSize(pagingEvent.pageSize);
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.data;
    let excludedColumns: string[] = this.columns
      .filter((column: ITdDataTableColumn) => {
        return ((column.filter === undefined && column.hidden === true) ||
          (column.filter !== undefined && column.filter === false));
      }).map((column: ITdDataTableColumn) => {
        return column.name;
      });
    // Need to filter by branch?
    if (this.branchFilter != 'ALL') {
      newData = newData.filter((d) => { return d['branch_code'] == this.branchFilter });
    }

    newData = this._dataTableService.filterData(newData, this._settingsService.getSearchTerm('invoice'), true, excludedColumns);
    this.filteredTotal = newData.length;
    if (this.sortBy == 'invoice_date') {
      newData = newData.sort(
        (item1, item2) => {
          return (new Date(item1.invoice_date) > new Date(item2.invoice_date) ? 1 : -1) * ((this.sortOrder == TdDataTableSortingOrder.Descending) ? 1 : -1);
        }
      );
    } else {
      newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    }
    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }

    this.filteredData = newData;
  }

}


// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/accounting/invoice-list/invoice-list.component.ts